import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null });

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("sd_token")) {
      setState({ loading: false, user: null });
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setState({ loading: false, ...data });
    } catch {
      localStorage.removeItem("sd_token");
      setState({ loading: false, user: null });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const applySession = (data) => {
    localStorage.setItem("sd_token", data.token);
    setState({ loading: false, ...data });
    return data;
  };
  const login = async (identifier, password, portal) => applySession((await api.post("/auth/login", { identifier, password, portal })).data);
  const logout = () => {
    localStorage.removeItem("sd_token");
    setState({ loading: false, user: null });
  };

  return <AuthCtx.Provider value={{ ...state, refresh, login, logout, applySession }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (role) => ({ admin: "/admin", merchant: "/seller", customer: "/customer" }[role] || "/");

export function RequireRole({ roles, children, loginPath = "/login" }) {
  const { loading, user } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-10 text-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to={`${loginPath}?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
